import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Popover } from "@mui/material";
import {
  Box,
  CssBaseline,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  Drawer,
  Collapse
} from "@mui/material";

import {
  Dashboard,
  Menu,
  ExpandLess,
  ExpandMore,
  AddBoxOutlined,
  Edit,
  Gavel,
  Logout,
  SignalCellularAltOutlined
} from "@mui/icons-material";

import { styled } from "@mui/material/styles";

import { toast } from "react-toastify";

import { resetContact } from "../redux/reducers/contactReducer";
import { resetHomeRe } from "../redux/reducers/homeReducer";
import { paths } from "../config/constants";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../redux/reducers/login";
import { logoutUser } from "../component/Elements/Session";
import Logo from "../Assets/Images/logo.png";
import useSessionTimeout from "../component/Elements/useSessionTimeout";
/* ================= WIDTH ================= */

const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 70;

/* ================= STYLES ================= */

const SidebarContainer = styled(Box)(({ collapsed }) => ({
  width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded,
  backgroundColor: "#0E4672",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
  height: "100%"
}));

const StyledItem = styled(ListItemButton)(({ active }) => ({
  padding: "12px 20px",
  color: "#fff",
  borderLeft: active ? "4px solid #f16729" : "4px solid transparent",
  backgroundColor: active ? "#293846" : "transparent",
  "&:hover": {
    backgroundColor: "#293846",
    color: "#fff"
  }
}));

/* ================= SIDEBAR ================= */

function SidebarContent({ collapsed }) {
const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
const [anchorEl, setAnchorEl] = useState(null);
  const reduxdata = useSelector((state) => state);
  const userId = reduxdata?.login?.user?.data?._id;
  let token = reduxdata?.login?.token;

  const [openTermsAndPolicies, setOpenTermsAndPolicies] = useState(false);

  const [isProfileCompleted, setIsProfileCompleted] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [role, setRole] = useState(null);
  const [bluCommission, setBluCommission] = useState(null);
  const [deactivatedStatusReason, setDeactivatedStatusReason] = useState(null);
useSessionTimeout();
  /* ================= SESSION CHECK ================= */

const handleLogout = async () => {
  await logoutUser({
    dispatch,
    navigate,
  });
};

const handleExpire = async () => {
  await logoutUser({
    dispatch,
    navigate,
    expired: true,
  });
};

  /* ================= FETCH USER ================= */

  const fetchData = async () => {

    let obj = {
      userId: userId
    };

    try {

      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/getUserProfile`,
        obj
      );
      setIsProfileCompleted(res?.data?.data?.isProfileCompleted);
      setAccountType(res?.data?.data?.accountType);
      setRole(res?.data?.data?.role);
      setBluCommission(res?.data?.data?.bluCommission);
      setDeactivatedStatusReason(res?.data?.data?.deactivatedStatusReason);
    } catch (error) {}

  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= SIDEBAR ================= */

  return (

    <SidebarContainer collapsed={collapsed}>

      {/* LOGO */}

      <Box
        onClick={() => navigate(paths.user.dashboard)}
        sx={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          cursor: "pointer"
        }}
      >

       <img
          src="https://blu.taxi/static/media/BLU%20TAXI%20white%20logo.4f586d7f9285146a885b.png"
          alt="BLU TAXI"
          style={{ width: collapsed ? 40 : 140 }}
        />

      </Box>

      <List>

        {/* DASHBOARD */}


            <StyledItem
  active={location.pathname === paths.user.dashboard}
  onClick={() => navigate(paths.user.dashboard)}
        >

          <ListItemIcon sx={{ color: "#fff" }}>
            <Dashboard />
          </ListItemIcon>

          {!collapsed && <ListItemText primary="Dashboard" />}

        </StyledItem>

        {/* CREATE BOOKING */}

       <StyledItem
  active={location.pathname === paths.home}
  onClick={() => navigate(paths.home)}
>

          <ListItemIcon sx={{ color: "#fff" }}>
            <AddBoxOutlined />
          </ListItemIcon>

          {!collapsed && <ListItemText primary="Create Booking" />}

        </StyledItem>

        {/* EDIT PROFILE */}

      <StyledItem
  active={location.pathname === paths.user.editProfile}
  onClick={() => navigate(paths.user.editProfile)}
>

          <ListItemIcon sx={{ color: "#fff" }}>
            <Edit />
          </ListItemIcon>

          {!collapsed && <ListItemText primary="Edit Profile" />}

        </StyledItem>


<StyledItem
              active={location.pathname === paths.user.rideReport}
              onClick={() => navigate(paths.user.rideReport)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <SignalCellularAltOutlined />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Ride Report" />}
            </StyledItem>


        {/* TERMS */}

       <StyledItem
  active={
    location.pathname === paths.user.bookingTermsAndCond ||
    location.pathname === paths.user.cancellationPolicy
  }
  onClick={(e) => {
    if (collapsed) {
      setAnchorEl(e.currentTarget); // open popup
    } else {
      setOpenTermsAndPolicies(!openTermsAndPolicies); // normal expand
    }
  }}
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <Gavel />
  </ListItemIcon>

  {!collapsed && (
    <>
      <ListItemText primary="Terms & Policies" />
      {openTermsAndPolicies ? <ExpandLess /> : <ExpandMore />}
    </>
  )}
</StyledItem>

        <Collapse in={openTermsAndPolicies && !collapsed} timeout="auto">

          <List component="div" disablePadding>

            <StyledItem
  active={location.pathname === paths.user.bookingTermsAndCond}
  sx={{ pl: 6 }}
  onClick={() => navigate(paths.user.bookingTermsAndCond)}
>
              <ListItemText primary="Terms and Conditions" />
            </StyledItem>

            <StyledItem
  active={location.pathname === paths.user.cancellationPolicy}
  sx={{ pl: 6 }}
  onClick={() => navigate(paths.user.cancellationPolicy)}
>
              <ListItemText primary="Cancellation Policy" />
            </StyledItem>

          </List>

        </Collapse>

        <Popover
  open={Boolean(anchorEl)}
  anchorEl={anchorEl}
  onClose={() => setAnchorEl(null)}
  anchorOrigin={{
    vertical: "center",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "center",
    horizontal: "left",
  }}
  PaperProps={{
    sx: {
      backgroundColor: "#0E4672",
      color: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
    }
  }}
>
  <List sx={{ minWidth: 200 }}>

    <ListItemButton
      sx={{
        color: "#fff",
        "&:hover": {
          backgroundColor: "#293846"
        }
      }}
      onClick={() => {
        navigate(paths.user.bookingTermsAndCond);
        setAnchorEl(null);
      }}
    >
      <ListItemText primary="Terms and Conditions" />
    </ListItemButton>

    <ListItemButton
      sx={{
        color: "#fff",
        "&:hover": {
          backgroundColor: "#293846"
        }
      }}
      onClick={() => {
        navigate(paths.user.cancellationPolicy);
        setAnchorEl(null);
      }}
    >
      <ListItemText primary="Cancellation Policy" />
    </ListItemButton>

  </List>
</Popover>

        {/* LOGOUT */}

        <StyledItem onClick={handleLogout}>

          <ListItemIcon sx={{ color: "#ff4d4f" }}>
            <Logout />
          </ListItemIcon>

          {!collapsed && (
            <ListItemText primary="Logout" sx={{ color: "#ff4d4f" }} />
          )}

        </StyledItem>

      </List>

    </SidebarContainer>

  );

}

/* ================= MAIN LAYOUT ================= */

export default function UserLayout() {

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:1024px)");
  const isLaptopOrAbove = useMediaQuery("(min-width:1025px)");

  const username = localStorage.getItem("userName");
  const userId = localStorage.getItem("userID");

  const [collapsed, setCollapsed] = useState(false);
  const [mobileCollapsed, setMobileCollapsed] = useState(true);

  const handleMenuClick = () => {

    if (isMobile || isTablet) {

      setMobileCollapsed(prev => !prev);

    } else {

      setCollapsed(prev => !prev);

    }

  };

  return (

    <Box sx={{ display: "flex", minHeight: "100vh" }}>

      <CssBaseline />

      {/* DESKTOP SIDEBAR */}

      {isLaptopOrAbove && (

        <Box sx={{ width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded }}>

          <SidebarContent collapsed={collapsed} />

        </Box>

      )}

      {/* MOBILE DRAWER */}

      {(isMobile || isTablet) && (

        <Drawer
          variant="temporary"
          open={!mobileCollapsed}
          onClose={() => setMobileCollapsed(true)}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidthExpanded,
              backgroundColor: "#0E4672"
            }
          }}
        >

          <SidebarContent collapsed={false} />

        </Drawer>

      )}

      {/* MAIN CONTENT */}

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0
        }}
      >

        {/* HEADER */}

        <Box
          sx={{
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            borderBottom: "1px solid #e5e5e5",
            position: "relative"
          }}
        >

          <IconButton
            onClick={handleMenuClick}
            sx={{
              backgroundColor: "#f16729",
              color: "#fff",
              "&:hover": { backgroundColor: "#f16729" }
            }}
          >
            <Menu />
          </IconButton>

          {/* DASHBOARD TITLE */}

          {!isMobile && (

            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                fontWeight: 600,
                fontSize: 16
              }}
            >
              User Dashboard
            </Box>

          )}

          {/* USER */}

          <Box
            sx={{
              textAlign: "right",
              mr: { xs: 3, sm: 5, md: 0 }
            }}
          >

            <Box sx={{ fontSize: 15, fontWeight: 600 }}>
              {username}
            </Box>

            <Box sx={{ fontSize: 14 }}>
              ID: {userId}
            </Box>

          </Box>

        </Box>

        {/* PAGE CONTENT */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: "#f3f3f4",
            px: { xs: 2, sm: 3, md: 4 },
            py: 3,
            width: "100%",
            overflowX: "hidden"
          }}
        >

          <Outlet />

        </Box>

      </Box>

    </Box>

  );

}
